import dayjs from 'dayjs'

export const DEFAULT_VOE_VERIFICATION_PERIOD_MONTHS = 36

/**
 * Check if an employment end date is before the verification cutoff.
 * Uses end-of-month for the employment date vs start-of-month for the cutoff,
 * so e.g. March 2023 is NOT expired in March 2026, only in April 2026.
 */
export const isExpiredEmployment = (
  endDate: string | null | undefined,
  periodMonths: number = DEFAULT_VOE_VERIFICATION_PERIOD_MONTHS
): boolean => {
  if (!endDate) return false
  const endOfMonth = dayjs(endDate).endOf('month')
  const cutoff = dayjs().subtract(periodMonths, 'month').startOf('month')
  return endOfMonth.isBefore(cutoff)
}

/**
 * Format a verification period for display.
 * Returns "3 years" when evenly divisible by 12, otherwise "18 months".
 */
export const formatVerificationPeriod = (months: number): string => {
  if (months % 12 === 0) {
    const years = months / 12
    return `${years} ${years === 1 ? 'year' : 'years'}`
  }
  return `${months} ${months === 1 ? 'month' : 'months'}`
}

/**
 * Get the dayjs cutoff date for the verification period.
 */
export const getVerificationCutoffDate = (
  periodMonths: number = DEFAULT_VOE_VERIFICATION_PERIOD_MONTHS
): dayjs.Dayjs => {
  return dayjs().subtract(periodMonths, 'month').startOf('month')
}
